module.exports = __webpack_public_path__ + "img/fexspace-user - dark.b3614f37.svg";